import styled from 'styled-components';

import { convertPxToRem } from '@proprioo/salatim';

export const Layout = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const GmapWrapper = styled.div`
  display: inline-block;
  flex: 1;
`;

export const TagsWrapper = styled.div`
  width: 100%;
  margin: 0 0 -${convertPxToRem(4)} 0;
  display: flex;
  flex-wrap: wrap;

  > span {
    z-index: 1;

    :last-of-type {
      margin-right: ${convertPxToRem(16)};
    }
  }
`;
